import React, { useRef } from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Col, Input, Modal, Pagination, Select, Space, Spin, Table } from "antd";
import { CheckOutlined, DeleteFilled, PlusCircleOutlined, PlusOutlined, MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import ControlBox from "./ControlBox";
import GroupTabRight from "./GroupTabRight";
import axios from "axios";
import InsertGroupModal from "./InsertGroupModal";
import EditGroupModal from "./EditGroupModal";


const backend = process.env.REACT_APP_BACKEND
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 92%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: right;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`

function GroupTab ({languageGroup}) {
  const [sourceData, setSourceData] = useState([])
  const [insertModal, setInsertModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [newCode, setNewCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [reRender, setReRender] = useState(false)
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [rightBox, setRightBox] = useState([false,{}])
  const [rowIndex, setRowIndex] = useState(null)
  const modalRef = useRef(null)
  const pageRef = useRef(false) // editModal에서 페이지 전환시 깜빡임을 없애기 위한 꼼수
  const preRowIndex = useRef(null)
  const deleteRef = useRef(false)

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSizeOptions: [5, 10, 50, 100, 200],
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      showTotal: (total)=>`total ${total} items`,
      total:0
    },
    filters: {
    },
    sorter: {

    }
  });

  const stateHandler = (stateName, state) => {
    const {current, pageSize, total } = tableParams.pagination
    const maxPage = total%pageSize === 0 ? total/pageSize : parseInt(total/pageSize)+1
    const remainder = total%pageSize || pageSize
    switch (stateName) {
      case "loading" :
        setLoading(state)
        break
      case "insertModal" :
        setInsertModal(state)
        break
      case "editModal" :
        setEditModal(state)
        break
      case "rightBox" :
        setRightBox(state)
        break
      case "rowIndex" :
        setRowIndex(state)
      case "reRender" :
        setReRender(!reRender)
        break
      case "rowIndex-" : 
        if(rowIndex === 0) {
          if(current === 1) {
          } else {
            setTableParams({
              ...tableParams,
              pagination: {
                ...tableParams.pagination,
                current: current - 1
              }
            })
            pageRef.current = true
            setRowIndex(pageSize -1)
          }
        } else {
          setRowIndex(state -1)
        }
        break
      case "rowIndex+" :
        if(current === maxPage) {
          if(rowIndex < remainder -1) {
            setRowIndex(state+1)
          }
        } else {
          if(rowIndex < pageSize -1) {
            setRowIndex(state+1)
          } else {
            setTableParams({
              ...tableParams,
              pagination: {
                ...tableParams.pagination,
                current: current + 1
              }
            })
            pageRef.current = true
            setRowIndex(0)
          }
        }
        break

      default : 
        break
    }
  }

  // const tableParamsHandler = (pagination) => {
  //   setTableParams({
  //     ...tableParams,
  //     pagination
  //   })
  // }
  const paginationHandler = (current,pageSize) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: current,
        pageSize: pageSize,
      }
    })
  }

  const columns = [
    {
      title: "순서",
      key: "sort",
      width: "60px"
    },
    {
      title: "그룹 코드",
      dataIndex: "code",
      key: "code",
      width: "150px"
    },
    {
      title: "그룹 제목(한국어)",
      dataIndex: "title",
      key: "title",
      width: "200px"
    },
    {
      title: "단어장 수",
      dataIndex: "VocabularyEx_count",
      key: "VocabularyEx_count",
      width: "100px",
      render: (_)=><div style={{color: _ === 0 ? "red" : null}}>{_}</div>
    },
    {
      title: "단어 수",
      dataIndex: "word_count",
      key: "word_count",
      width: "100px",
      render: (_)=><div style={{color: _ === 0 ? "red" : null}}>{_}</div>
    },
    {
      title: "처리",
      dataIndex: "",
      width: "110px",
      render: (_,record) =>
      <div>
        <a style={{margin:"0px 5px"}} onClick={(e)=>{e.stopPropagation();editHandler(_)}}>수정</a>
        <a style={{margin:"0px 5px"}} onClick={(e)=>{e.stopPropagation();deleteHandler(_)}}>삭제</a>
      </div>
    },
    {}
  ]

  const getSourceData = () => {
    setLoading(true)
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter.column?.dataIndex || "code"
    const sorterDirection = tableParams.sorter.order === "descend" ? "DESC" : "ASC"

    axios.get(`${backend}/contents/word_dictionary/group/list`,
    {params:{
      // ...baseParams,
      current: current,
      pageSize: pageSize,
      sorterCol: sorterCol,
      sorterDirection: sorterDirection
    }})
    .then(res=>{
      // const newSource = res.data.data[0]
      const newSourceData = res.data.data[0].map((el,idx)=>{
        el.indexNumber = idx
        el.id = el.code
        return el
      })
      
      const total = res.data.data[1][0]["FOUND_ROWS()"]
      const maxCode = res.data.data[2][0].max_code
      const maxCodeNumber = Number(maxCode?.slice(2)) || 0
      const newCode = "WG" + ("000" + String(maxCodeNumber + 10)).slice(-4)
    
      pageRef.current = false // page가 변동 시 editModal창의 데이터 변형을 위한 꼼수

      setSourceData(newSourceData)
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: total
        }
      })
      setNewCode(newCode)
      
      if(rightBox[0]) {
        if(deleteRef.current) {
          setRowIndex(newSourceData.length -1)
        } else {
          if(rowIndex > newSourceData.length -1) {
            setRowIndex(null)
            setRightBox([false,{}])
          } else {
            if(preRowIndex.current) {
              setRowIndex(preRowIndex.current-1)
            } else {
              setRightBox([true, newSourceData[rowIndex]])
            }
          }
        }
      }

    })
    .catch(err=>{
      console.log(err)
    })
    .finally(()=>{
      setLoading(false)
    })
  }

  const Row = ({ children, ...props }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({
      id: props['data-row-key'],
    });
    const style = {
      ...props.style,
      transform: CSS.Transform.toString(
        transform && {
          ...transform,
          scaleY: 1,
        },
      ),
      transition,
      ...(isDragging
        ? {
            position: 'relative',
            zIndex: 9999,
          }
        : {}),
    };
  
    return (
      <tr {...props} ref={setNodeRef} style={sourceData.length ? style : null} {...attributes}>
        {React.Children.map(children, (child) => {
          if (child.key === 'sort') {
            return React.cloneElement(child, {
              children: (
                <MenuOutlined
                  ref={setActivatorNodeRef}
                  style={{
                    touchAction: 'none',
                    cursor: 'move',
                  }}
                  {...listeners}
                />
              ),
            });
          }
          return child;
        })}
      </tr>
    );
  };

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      let start = 0
      let end = 0
      const tempSourceData = JSON.parse(JSON.stringify(sourceData))
      const changeOrder = (previous) => {
        const activeIndex = previous.findIndex((i) => i.id === active.id);
        const overIndex = previous.findIndex((i) => i.id === over?.id);
        start = Math.min(activeIndex, overIndex)
        end = Math.max(activeIndex, overIndex)
        return arrayMove(previous, activeIndex, overIndex);
      }
      const newSourceData = changeOrder(tempSourceData)
      // 선택되어 있을 때 순서가 변경되면 선택된 것도 변경해줘야 한다.

      if(rowIndex !==null && rightBox[0]) {

        const changeRowIndex = newSourceData.findIndex((i)=>i.indexNumber === rowIndex)
        setRowIndex(changeRowIndex)
      }
      setSourceData(newSourceData)
      const dataArray = newSourceData.filter(el=> el.indexNumber >= start && el.indexNumber <= end)
      const newIds = dataArray.map(el=>el.id)
      const minOrder = Math.min(...dataArray.map(el=>el.order))
      
      axios
      .patch(`${backend}/contents/word_dictionary/group/order`,{newIds, minOrder})
      .then(res=>{
        setReRender(!reRender)
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title: "순서변경 오류",
          content: "DB오류로 순서를 변경하지 못했습니다.",
          okText: "확인",
          afterClose: ()=>{setSourceData(tempSourceData)}
        })
      })
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    type: "checkbox",
    onChange: (keys, rows) => {
      setSelectedRows(rows.sort((a, b) => a.num - b.num));
      setSelectedKeys(keys.sort((a, b) => a - b));
    },
    getCheckboxProps: (record) => ({
      // disabled: record.hideCheckbox, // 특정 조건일 경우 사용하지 체크하지 못하도록 함
      // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능

    })
  }

  // 각 행별 이벤트를 모아놓은 객체를 리턴한다. 필요한 경우에만 사용하도록.
  const onRowHandler = (record, rowIdx) => {
    return {
      onClick : () => {
        if(rowIndex === rowIdx) {
          setRightBox([false,{}])
          setRowIndex(null)
        } else {
          setRightBox([true, record])
          setRowIndex(rowIdx)
        }
      }
    }
  }

  const editHandler = (_) =>{
    setRowIndex(_.indexNumber)
    if(rightBox[0]) {
      setRightBox([true, _])
    }
    setEditModal(true)
  }

  const deleteHandler = (_) => {
    if(_.VocabularyEx_count !== 0 || _.word_count !== 0) {
      Modal.error({
        title: "에러",
        content: "선택한 그룹코드에는 단어장이 등록되어 있습니다. 해당하는 단어장을 먼저 삭제하세요.",
        okText: "확인"
      })
    } else {
      axios.delete(`${backend}/contents/word_dictionary/group/list/${_.code}`)
      .then(res=>{
        Modal.success({
          title: "삭제 완료",
          content: "정상적으로 삭제 되었습니다.",
          okText: "확인"
        })
        //페이지에 한개밖에 없을 경우 삭제했을때.
        if(_.indexNumber === 0 && sourceData.length === 1) {
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              current : tableParams.pagination.current -1
            }
          })
          deleteRef.current = true
        } else {
          setReRender(!reRender)
          if(rowIndex && _.indexNumber < rowIndex) {
            preRowIndex.current = rowIndex
          }
        }
      })
      .catch(err=>{
        console.log(err)
      })
    }
  }

  useEffect(()=>{
    getSourceData()
  },[tableParams.pagination.pageSize, tableParams.pagination.current, tableParams.sorter, reRender])

  useEffect(()=>{
    if(rightBox[0] && rowIndex !== null) {
      setRightBox([true, sourceData[rowIndex]])
    }
    preRowIndex.current = null
    deleteRef.current = false
  },[rowIndex])

  return (
    <div style={{display: "flex", flexDirection:"column", height:"100%"}}>

      {insertModal && <InsertGroupModal insertModal={insertModal} stateHandler={stateHandler} newCode={newCode}/>}
      {editModal && <EditGroupModal editModal={editModal} stateHandler={stateHandler} data={sourceData[rowIndex]} pageRef={pageRef}/>}

      <Spin className="mySpin" spinning={loading}>
        <div style={{display:"flex", justifyContent:"space-between", marginBottom:"10px"}}>
          <span style={{ minWidth: "100px", textAlign: "left" }}>문장 목록</span>
          <ControlBox stateHandler={stateHandler}/>
        </div>
        
        <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
          
          <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
            <SortableContext
              // rowKey array
              items={sourceData.map((i) => i.id)}
              strategy={verticalListSortingStrategy}
            >
              <StyledTable
                className="pageTable"
                onRow={onRowHandler}
                // rowSelection={rowSelection} // 체크박스 활용하고 싶다면 활성화
                rowClassName={(record, index) => {
                  return index === rowIndex ? "selectedRow" : "";
                }}
                columns={columns}
                dataSource={sourceData}
                rowKey="code"
                // onChange={tableParamsHandler}
                pagination={tableParams.pagination}
                style={{flexGrow:1, overflow:"auto"}}
                scroll = {{ x:"max-content", y:"max-content"}}
                components={{
                  body: {
                    row: Row,
                  },
                }}
                footer={()=>
                  <div className="custom-footer">
                    <Pagination {...tableParams.pagination} onChange={paginationHandler}/>
                  </div>}
              />
              {rightBox[0] ? <GroupTabRight rightBox={rightBox} languageGroup={languageGroup} stateHandler={stateHandler} pageRef={pageRef}/> : null}
            </SortableContext>
          </DndContext>

        </div>
      </Spin>
    </div>
  )
}

export default GroupTab